import React from 'react';
import { useLocation, Link } from 'react-router-dom';

import Signin from '../Tuning/Pages/Authentication/Signin';
import Signup from '../Tuning/Pages/Authentication/Signup';
import PasswordReset from '../Tuning/Pages/Authentication/PasswordReset';
import TwoStep from '../Tuning/Pages/Authentication/TwoStep';
import Lockscreen from '../Tuning/Pages/Authentication/Lockscreen';
import Maintenance from '../Tuning/Pages/Authentication/Maintenance';

// Maps pathname directly to the component — no intermediate title string needed
const AUTH_ROUTE_MAP = {
    "/signin": <Signin />,
    "/signup": <Signup />,
    "/password-reset": <PasswordReset />,
    "/two-step": <TwoStep />,
    "/lockscreen": <Lockscreen />,
    "/maintenance": <Maintenance />,
};

const AuthLayout = () => {
    const { pathname } = useLocation();
    const PageComponent = AUTH_ROUTE_MAP[pathname] ?? null;

    return (
        <div data-ha="theme-PurpleHeart" className="svgstroke-a auth bg-gradient">
            <main className="container">

                {/* Logo */}
                <div className="px-xl-5 px-2 auth-header" data-bs-theme="none">
                    <Link to="/" className="brand-icon text-decoration-none d-flex align-items-center" title="PatidarSamaj Admin Template">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                            <path d="M9 8l0 8" />
                            <path d="M9 12l6 0" />
                            <path d="M15 8l0 8" />
                        </svg>
                        <span className="fw-bold ps-2 fs-5 text-gradient">PatidarSamaj</span>
                    </Link>
                </div>

                {/* Page body */}
                {PageComponent}

                {/* Footer */}
                <footer className="px-xl-5 px-2">
                    <p className="text-muted">
                        © {new Date().getFullYear()}{" "}
                        <Link to="/" target="_blank" title="patidar-samaj">PatidarSamaj</Link>
                        , All Rights Reserved.
                    </p>
                </footer>

            </main>
        </div>
    );
};

export default AuthLayout;